import { createSlice } from '@reduxjs/toolkit';

export const projectsSlice = createSlice({
    name: "projects",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const projectsActions = projectsSlice.actions;

export default projectsSlice.reducer;